import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../Components/Table';
import { Button } from 'retro';
import { Filter, Download } from 'lucide-react';
import { summaryStats, auditLogData } from '../Data/mockData';

export default function Audit() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>

      {/* Summary Stats */}
      <div>
        <h2 style={{ fontSize: 18, fontWeight: 600, color: '#111827', marginBottom: 16 }}>Audit Overview</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16 }}>
          {summaryStats.map((stat, index) => (
            <div
              key={index}
              style={{
                borderRadius: 8,
                padding: 16,
                border: '1px solid #e5e7eb',
                backgroundColor: stat.color?.bg || '#f9fafb',
              }}
            >
              <div style={{ fontSize: 12, fontWeight: 500, marginBottom: 8 }}>{stat.label}</div>
              <div style={{ fontSize: 24, fontWeight: 700 }}>{stat.value}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Filters & Actions */}
      <div style={{ backgroundColor: '#ffffff', borderRadius: 8, border: '1px solid #e5e7eb', padding: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 16 }}>
          
          <div style={{ display: 'flex', gap: 16 }}>
            {/* Date Range */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 14, fontWeight: 500, color: '#374151' }}>Date Range:</span>
              <select style={{ padding: '4px 8px', borderRadius: 6, border: '1px solid #d1d5db' }}>
                <option value="today">Today</option>
                <option value="week">Last 7 Days</option>
                <option value="month">Last 30 Days</option>
                <option value="custom">Custom Range</option>
              </select>
            </div>

            {/* Action Type */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 14, fontWeight: 500, color: '#374151' }}>Action Type:</span>
              <select style={{ padding: '4px 8px', borderRadius: 6, border: '1px solid #d1d5db' }}>
                <option value="all">All Actions</option>
                <option value="bin">BIN Changes</option>
                <option value="mcc">MCC Changes</option>
                <option value="limit">Limit Changes</option>
                <option value="user">User Changes</option>
                <option value="corporate">Corporate Changes</option>
              </select>
            </div>

            {/* Admin User */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 14, fontWeight: 500, color: '#374151' }}>Admin User:</span>
              <select style={{ padding: '4px 8px', borderRadius: 6, border: '1px solid #d1d5db' }}>
                <option value="all">All Admins</option>
                <option value="admin1">admin@emiratesnbd.ae</option>
                <option value="admin2">superadmin@emiratesnbd.ae</option>
                <option value="admin3">manager@emiratesnbd.ae</option>
              </select>
            </div>
          </div>

          {/* Buttons */}
          <div style={{ display: 'flex', gap: 8 }}>
            <Button variant="outline" size="sm" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Filter style={{ width: 16, height: 16, marginRight: 4 }} />
              More Filters
            </Button>
            <Button variant="outline" size="sm" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Download style={{ width: 16, height: 16, marginRight: 4 }} />
              Export
            </Button>
          </div>
        </div>
      </div>

      {/* Audit Log Table */}
      <div style={{ backgroundColor: '#ffffff', borderRadius: 8, border: '1px solid #e5e7eb' }}>
        <div style={{ padding: 24, borderBottom: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2 style={{ fontSize: 18, fontWeight: 600, color: '#111827' }}>Audit Activity Log</h2>
          <div style={{ fontSize: 14, color: '#6b7280' }}>Showing {auditLogData.length} entries</div>
        </div>
        <div style={{ overflowX: 'auto' }}>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Action Type</TableHead>
                <TableHead>Entity</TableHead>
                <TableHead>Old Value</TableHead>
                <TableHead>New Value</TableHead>
                <TableHead>Admin User</TableHead>
                <TableHead>Timestamp</TableHead>
                <TableHead>Details</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {auditLogData.map((row) => {
                let bgColor, textColor;
                if (row.actionType.includes('Blocked') || row.actionType.includes('Revoked')) {
                  bgColor = '#fee2e2'; textColor = '#b91c1c';
                } else if (row.actionType.includes('Updated') || row.actionType.includes('Modified')) {
                  bgColor = '#ffedd5'; textColor = '#ea580c';
                } else if (row.actionType.includes('Enabled') || row.actionType.includes('Onboarded')) {
                  bgColor = '#dcfce7'; textColor = '#16a34a';
                } else {
                  bgColor = '#dbeafe'; textColor = '#3b82f6';
                }

                return (
                  <TableRow key={row.id} style={{ cursor: 'pointer', transition: 'background-color 0.2s', backgroundColor: '#ffffff', hover: { backgroundColor: '#f9fafb' } }}>
                    <TableCell>
                      <span style={{ display: 'inline-flex', padding: '2px 8px', fontSize: 12, fontWeight: 500, borderRadius: 9999, backgroundColor: bgColor, color: textColor }}>
                        {row.actionType}
                      </span>
                    </TableCell>
                    <TableCell style={{ fontWeight: 500 }}>{row.entity}</TableCell>
                    <TableCell style={{ color: '#4b5563' }}>{row.oldValue}</TableCell>
                    <TableCell style={{ fontWeight: 500 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                        <span style={{ color: '#16a34a' }}>→</span>
                        {row.newValue}
                      </div>
                    </TableCell>
                    <TableCell style={{ fontSize: 14 }}>{row.adminUser}</TableCell>
                    <TableCell style={{ fontSize: 14, color: '#6b7280' }}>{row.timestamp}</TableCell>
                    <TableCell>
                      <button style={{ fontSize: 12, color: '#2563eb', fontWeight: 500, background: 'none', border: 'none', cursor: 'pointer' }}>View</button>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      </div>

      {/* Compliance Notes */}
      <div style={{ backgroundColor: '#eff6ff', border: '2px solid #bfdbfe', borderRadius: 8, padding: 24 }}>
        <h3 style={{ fontSize: 14, fontWeight: 600, color: '#1e40af', marginBottom: 12 }}>Compliance & Governance Notes</h3>
        <ul style={{ display: 'flex', flexDirection: 'column', gap: 8, fontSize: 14, color: '#1e3a8a', paddingLeft: 16 }}>
          <li style={{ display: 'flex', gap: 4 }}><span style={{ color: '#3b82f6' }}>•</span>All changes are logged and stored for regulatory compliance (7 years retention)</li>
          <li style={{ display: 'flex', gap: 4 }}><span style={{ color: '#3b82f6' }}>•</span>Critical actions require dual authorization and are flagged for review</li>
          <li style={{ display: 'flex', gap: 4 }}><span style={{ color: '#3b82f6' }}>•</span>Audit logs are tamper-proof and include cryptographic signatures</li>
          <li style={{ display: 'flex', gap: 4 }}><span style={{ color: '#3b82f6' }}>•</span>Automated alerts are sent for high-risk or unusual administrative actions</li>
        </ul>
      </div>
    </div>
  );
}
